import Vue from 'vue'

/**
 * @author jorge nuñez lópez <>
 *
 * Get movements from a specific warehouse
 * @return {object}
 */

const transformer = (data) => ({
  id: data.id,
  currentQuantity: data.current_quantity,
  movementType: data.movement_type,
  order: data.order,
  quantityEntry: data.quantity_entry,
  responsible: data.responsible,
  unitPrice: data.unit_price
})

function urlParamsTransformer(options) {
  return {
    page: options.page,
    size: options.pageSize,
    supply: options.supply,
    ascending_order: options.asc ? true : undefined,
  }
}

export default (warehouseId, fetchOptions) => {
  const params = fetchOptions ? urlParamsTransformer(fetchOptions) : null

  return Vue.$http.get(`purchase/warehouse/${warehouseId}/supply-adjustments/`, { params })
    .then(response => {
      const { results, ...paginationInfo} = response.data
      const movements = results.map(m => transformer(m))
      return { movements, paginationInfo }
    })
    .catch((error) => {
      const response = error.response

      if (response && response.status !== 404) {
        throw error
      }
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchMovements.js